import { useEffect, useState } from 'react'
import { Typography } from 'antd'
import { useFFEStore } from '../../store/ffeStore'

const { Text } = Typography

export const SaveIndicator = () => {
  const [visible, setVisible] = useState(false)
  const [text, setText] = useState('')
  const [opacity, setOpacity] = useState(0)
  const saving = useFFEStore((state) => state.saving)
  const errorSaving = useFFEStore((state) => state.errorSaving)

  useEffect(() => {
    if (saving) {
      setText('Saving...')
      setVisible(true)
      setOpacity(1)
    } else {
      if (errorSaving) {
        setText('Failed to save')
        setOpacity(1)
      } else {
        setText('Saved')
        setOpacity(1)
      }

      // Start fade out after 2 seconds
      const fadeTimeout = setTimeout(() => {
        setOpacity(0)
      }, 2000)

      // Remove from DOM after fade completes
      const removeTimeout = setTimeout(() => {
        setVisible(false)
      }, 2300) // 2s delay + 300ms transition

      return () => {
        clearTimeout(fadeTimeout)
        clearTimeout(removeTimeout)
      }
    }
  }, [saving])

  if (!visible) return null

  return (
    <Text
      type="secondary"
      className="text-sm transition-opacity duration-300 me-2"
      style={{ opacity, color: errorSaving ? 'red' : 'inherit' }}
    >
      {text}
    </Text>
  )
}
